import { InjectionToken } from '@angular/core';
import { Company } from 'mbs-ui-shared@models';

export type AddStorageAccountWizardOptions = {
  companyIds?: string[];
  lockedCompany?: Company;
};

// The wizard itself lives in the app, so libraries reach it through this token instead of importing it
export type AddStorageAccountWizardOpener = (options?: AddStorageAccountWizardOptions) => Promise<boolean>;

export const ADD_STORAGE_ACCOUNT_WIZARD_OPENER = new InjectionToken<AddStorageAccountWizardOpener>('ADD_STORAGE_ACCOUNT_WIZARD_OPENER');
